module.exports = __webpack_public_path__ + "img/indomaret.02ee87c0.png";